var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import PrimarySidebarLayout from "../../Layout/PrimarySidebarLayout";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import CampaignPrimarySidebar from "../../Container/Campaign/CampaignPrimarySidebar";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import useService from "../../Hooks/useService";
import CampaignForm, { campaignFormStateToRequest, } from "../../Container/Campaign/CampaignForm/CampaignForm";
import { getCampaignDetailPath, getCampaignListPath, getCampaignNewPath, } from "./CampaignRoutes";
import useParams from "../../Hooks/useParams";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import CampaignService from "../../../Services/Campaign.service";
import CampaignTypeService from "../../../Services/CampaignType.service";
import PageTitle from "../../UI/PageTitle/PageTitle";
import { BasicFormFormat } from "../../UI/FormFormat/FormFormat";
import ContentLayout from "../../Layout/ContentLayout";
import ContentTemplateService from "../../../Services/ContentTemplate.service";
import PopulationService from "../../../Services/Population.service";
const ActionSelector = (props) => {
    const history = useHistory();
    const [actionState, loadActions] = useService(CampaignTypeService.restrictedList);
    React.useEffect(() => {
        loadActions();
    }, [loadActions]);
    return (_jsx(SecondaryNavLayout, { nav: _jsx(SecondaryNavButton, { icon: "chevron-left", iconType: "fal", label: "Back", onClick: () => history.push(getCampaignListPath({})) }), children: _jsxs(ContentLayout, { paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: [_jsx(PageTitle, { children: "Choose a Campaign Type" }), _jsx("div", { className: "row mt-4", children: _jsx(ServiceResult, { state: actionState, errorClassName: "col-md-11 ml-3", children: (actions) => {
                            return actions.map((action, index) => (_jsx("div", { className: "col-md-4 mb-4", children: _jsx(Link, { className: "card shadow no-underline h-100", to: getCampaignNewPath({
                                        actionId: action.id,
                                        populationId: props.populationId,
                                    }), children: _jsxs("div", { className: "card-body", style: { color: "black" }, children: [_jsx("h2", { className: "h4 card-title", children: action.title }), _jsx("div", { className: "card-text", children: action.description })] }) }) }, index)));
                        } }) })] }) }));
};
const DEFAULT_VALUES = {
    useInstitutionalEmail: "true",
    useSimpleEditor: "false",
    sendBehavior: "manual",
    inDragAndDropMode: "true",
    createTask: true,
    populationAdHocCaseloads: [],
};
const NewCampaignForm = (props) => {
    const history = useHistory();
    const saveButtonRef = useRef(null);
    const [actionsState, loadAction] = useService(CampaignService.getAction);
    const [campaignContentTemplateState, loadCampaignContentTemplate] = useService(ContentTemplateService.getCampaignTemplate);
    const [saveCampaignState, saveCampaign] = useService(CampaignService.save);
    React.useEffect(() => {
        loadAction(props.actionId);
    }, [loadAction, props.actionId]);
    React.useEffect(() => {
        if (props.campaignContentTemplateId) {
            loadCampaignContentTemplate(props.campaignContentTemplateId);
        }
    }, [loadCampaignContentTemplate, props.campaignContentTemplateId]);
    const getNewFormDefaultValues = (template) => __awaiter(void 0, void 0, void 0, function* () {
        let defaultFormValues = DEFAULT_VALUES;
        if (props.populationId) {
            const population = yield PopulationService.get(props.populationId);
            defaultFormValues = Object.assign(Object.assign({}, defaultFormValues), { population });
        }
        if (template) {
            defaultFormValues = Object.assign(Object.assign({}, defaultFormValues), { useSimpleEditor: template.isSimpleBody ? "true" : "false", simpleBody: template.simpleBody, htmlBody: template.htmlBody, template: template.templateDefinitionComponents, templateStyles: template.templateDefinitionStyles, templateAssets: template.assets, inDragAndDropMode: template.isDragAndDrop ? "true" : "false", campaignTemplateId: props.campaignContentTemplateId });
        }
        return defaultFormValues;
    });
    // When creating a new campaign from a template, we open up the link in a new tab, and it doesn’t make sense to allow
    // navigation using the back button to the action selector, so we redirect the user back to the campaigns list instead
    // If it is not a campaign template, we redirect them back to the action selector, with a population id, if one is provided
    const newCampaignBackPath = props.campaignContentTemplateId
        ? getCampaignListPath({})
        : getCampaignNewPath({ populationId: props === null || props === void 0 ? void 0 : props.populationId });
    return (_jsx(SecondaryNavLayout, { nav: _jsxs(_Fragment, { children: [_jsx(SecondaryNavButton, { icon: "chevron-left", iconType: "fal", label: "Back", onClick: () => history.push(newCampaignBackPath) }), actionsState.wasSuccessful && (_jsx(SecondaryNavButton, { icon: "save", iconType: "fas", label: "Save", type: "submit", onClick: () => {
                        var _a;
                        (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    }, isLoading: saveCampaignState.isLoading }))] }), children: _jsx(ContentLayout, { paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(ServiceResult, { state: campaignContentTemplateState, stillRenderChildWhenNoData: true, children: (template) => (_jsx(ServiceResult, { state: actionsState, children: (action) => (_jsx(BasicFormFormat, { defaultValue: () => __awaiter(void 0, void 0, void 0, function* () { return getNewFormDefaultValues(template); }), handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                            const formStateSaveRequest = campaignFormStateToRequest(formState);
                            yield saveCampaign(formStateSaveRequest).then((response) => {
                                history.push(getCampaignDetailPath({ id: response.id }));
                            });
                        }), saveButtonRef: saveButtonRef, respondToDefaultValueChanges: true, hideButtons: true, errorMessagePosition: "top", children: (formProps) => (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { children: ["New ", action.name, " Campaign"] }), _jsx(CampaignForm, Object.assign({ actionId: props.actionId }, formProps))] })) })) })) }) }) }));
};
const NewCampaign = () => {
    const params = useParams();
    const actionId = parseInt(params.actionId, 10);
    const templateId = params.templateId
        ? parseInt(params.templateId, 10)
        : undefined;
    const populationId = params.populationId
        ? parseInt(params.populationId, 10)
        : undefined;
    return (_jsx(PrimarySidebarLayout, { sidebar: (setIsOpen) => (_jsx(CampaignPrimarySidebar, { setIsOpen: setIsOpen, emailsOpen: true })), sidebarSize: "sm", children: () => actionId ? (_jsx(NewCampaignForm, { actionId: actionId, campaignContentTemplateId: templateId, populationId: populationId })) : (_jsx(ActionSelector, { populationId: populationId })) }));
};
export default NewCampaign;
